import cleanedFilename from '~/util/cleanedFilename';

export default {
  LoadableContainer: `${cleanedFilename(__filename)}-LoadableContainer`,
};
